<div class="app-layout" [class.nav-collapsed]="isNavCollapsed">
  <!-- <lib-vertical-nav [title]="appTitle"></lib-vertical-nav> -->

  <div class="main-content">
    <!-- Top bar -->
    @if (appTitle) {
    <div class="top-bar" [class.handset]="isHandset" [class.desktop]="!isHandset">
      <div class="top-bar-content">
        <h1 class="page-title">{{ appTitle }}</h1>
      </div>
    </div>
    }

    <!-- Main content area -->
    <div class="content-area" [class.handset]="isHandset" [class.desktop]="!isHandset">
      <ng-content></ng-content>
    </div>
  </div>
</div>